import Vue from 'vue'
import Vuex from 'vuex'
import cookie from '../../static/js/cookie'
import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'

Vue.use(Vuex)

// 全局引用cookie方法类
const userInfo = {
  username: cookie.getCookie('username') || '',
  name: cookie.getCookie('name') || '',
  token: cookie.getCookie('token') || '',
  system_num: cookie.getCookie('system_num') || 0,
}
const testlanguage = sessionStorage.getItem('testlanguage') || ''
const currentCity = JSON.parse(localStorage.getItem('currentCity'))|| ''
const needLogin = false
const state = {
  userInfo,
  needLogin,
  currentCity,
  testlanguage,
}
// console.log('1111+++',userInfo.headimg)
export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js